import { createContext, useContext, useState } from 'react';
import { VacationRequest } from '../types/vacations';

// datatype of the context declared here
interface IVacationRequestContext {
  vacationRequest: VacationRequest | null;
  showUpdateModal: boolean;
  showDeleteModal: boolean;
  showApproveModal: boolean;
  showRejectModal: boolean;
  setShowUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowApproveModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowRejectModal: React.Dispatch<React.SetStateAction<boolean>>;
  setVacationRequest: React.Dispatch<
    React.SetStateAction<VacationRequest | null>
  >;
}

// creating the context here
const VacationRequestContext = createContext<IVacationRequestContext | null>(
  null
);

const VacationRequestProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // integration of react hooks here
  const [vacationRequest, setVacationRequest] =
    useState<VacationRequest | null>(null);
  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showApproveModal, setShowApproveModal] = useState<boolean>(false);
  const [showRejectModal, setShowRejectModal] = useState<boolean>(false);

  // rendering the context provider here
  return (
    <VacationRequestContext.Provider
      value={{
        showUpdateModal,
        showDeleteModal,
        showApproveModal,
        showRejectModal,
        vacationRequest,
        setShowUpdateModal,
        setShowDeleteModal,
        setShowApproveModal,
        setShowRejectModal,
        setVacationRequest,
      }}
    >
      {children}
    </VacationRequestContext.Provider>
  );
};

export default VacationRequestProvider;

// custom hook to access vacation request context declared here
export const useVacationRequestContext = () => {
  const context = useContext(VacationRequestContext);

  if (!context) {
    throw new Error(
      'useVacationRequestContext must be within VacationContextProvider!'
    );
  }

  return context;
};
